<template>
  <div class="inner">
    <div class="row row-capsules">
      <div class="col-12-small col-6">
        <CreateForm @onFormSuccess="onFormSuccess" @onLocation="onLocation" />
      </div>
      <div class="col-12-small col-6-small col-6">
        <div class="capsule homes">
          <marquee id="mymarquee" behavior="scroll" direction="up" gap="0">
            <table class="table alt">
              <tbody>
                <tr v-for="(voice, index) in voices" :key="index">
                  <td>
                    <router-link :to="`/voice/${voice.id}`"
                      ><strong>{{ voice.type }}:</strong> {{ voice.topic }}
                      <span v-if="!city">({{ voice.city }})</span></router-link
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </marquee>
        </div>
        <div class="text-center">
          <button v-on:click="scrollUp" class="scrolling-button">
            <em class="fas fa-chevron-up" />
          </button>
          <button v-on:click="startOrStop" class="scrolling-button">
            <em v-if="scrolling" class="far fa-pause-circle" />
            <em v-else-if="!scrolling" class="far fa-play-circle" />
          </button>
          <button v-on:click="scrollDown" class="scrolling-button">
            <em class="fas fa-chevron-down" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.row-capsules div:first-child {
  order: 1;
  @media screen and (max-width: 900px) and (orientation: landscape),
    screen and (max-width: 480px) {
    order: 0;
  }
}

.capsule {
  padding: 0;
}

a {
  color: black;
}

table {
  margin: 0;
}
table td {
  padding: 0.25rem 0.25rem;
}

table.alt tbody tr:first-child td,
table.alt tbody tr:last-child td {
  border: 1px solid rgba(0, 0, 0, 0.125);
}
table.alt tbody tr:first-child td {
  border-radius: 10px 10px 0 0;
}
table.alt tbody tr:last-child td {
  border-radius: 0 0 10px 10px;
  border-top: 0;
}

.scrolling-button {
  // display: block;
  margin: 0 auto 1em;
  background-color: white;
  box-shadow: inset 0 0 0 1px rgba(99, 116, 133, 0.25);
  color: #637485 !important;
  border-radius: 4px;
  height: 2.5em;
  line-height: 1;
  overflow: scroll;

  em {
    font-size: 25px;
  }
}

.scrolling-button:nth-child(1) {
  border-right: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  margin-right: -1px;
}
.scrolling-button:nth-child(2) {
  border-left: 0;
  border-radius: 0px;
}
.scrolling-button:nth-child(3) {
  border-left: 0;
  margin-left: -1px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

marquee {
  display: block !important;
  max-height: 48vh;
  white-space: nowrap;
  @media screen and (max-width: 900px) and (orientation: landscape) {
    max-height: 70vh;
  }
}
</style>
<style lang="scss">
.wrapper {
  padding-top: 4rem;
}
.text-center {
  text-align: center;
}
</style>

<script>
import axios from 'axios';
// @ is an alias to /src
import CreateForm from '@/components/CreateForm.vue';

const IS_PRODUCTION = process.env.NODE_ENV === 'production';

const APIUrl = IS_PRODUCTION
  ? 'https://funtiny.appspot.com/'
  : 'http://localhost:5000';

export default {
  name: 'home',
  data() {
    return {
      voices: [],
      city: null,
      scrolling: false
    };
  },
  methods: {
    getVoices() {
      const path = `${APIUrl}/api/voices/`;
      axios
        .get(path)
        .then(res => {
          this.voices = res.data.filter(this.filter);
        })
        .catch(error => {
          // eslint-disable-next-line
          console.error(error);
        });
    },
    filter(voice) {
      if (!this.city) {
        return true;
      }
      return voice.city == this.city;
    },
    onFormSuccess() {
      this.getVoices();
    },
    onLocation(city) {
      this.city = city;
      this.getVoices();
    },
    startOrStop() {
      if (!this.scrolling) {
        document.getElementById('mymarquee').start();
      } else {
        document.getElementById('mymarquee').stop();
      }
      this.scrolling = !this.scrolling;
    },
    scrollUp() {
      this.scrolling = true;
      const m = document.getElementById('mymarquee');
      m.direction = 'up';
      m.start();
    },
    scrollDown() {
      this.scrolling = true;
      const m = document.getElementById('mymarquee');
      m.direction = 'down';
      m.start();
    }
  },
  created() {
    this.getVoices();
    setTimeout(() => {
      document.getElementById('mymarquee').stop();
    }, 0);
  },
  components: {
    CreateForm
  }
};
</script>
